
import { Vue } from "vue-class-component";
import { ForwardBookingCommissionController } from "@/app/ui/controllers/ForwardBookingCommissionController";

export default class ForwardBookingCommissionEditSectionGeneralConfig extends Vue {
  get detailData() {
    return ForwardBookingCommissionController.forwardBookingCommissionDetail;
  }
}
